import React, { useEffect, Ref } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import FarecardListItem from './FarecardListItem';
import { Farecard } from '../../services/types/apitypes';
import { cardsIsVisbleCard } from '../../utils/cards';

type FarecardListProps = {
  cards?: Farecard[];
  goToAdd: () => void;
  unlock: (f: Farecard) => void;
  addValue: (f: Farecard) => void;
  showOptions: (f: Farecard) => void;
  itemsRef: { current: Ref<{ fetchCappingPots: () => void }>[] };
};

export default function FarecardList({
  cards,
  unlock,
  goToAdd,
  addValue,
  showOptions,
  itemsRef,
}: FarecardListProps) {
  const [visible, setVisible] = React.useState<Farecard[]>([]);

  useEffect(() => {
    if (cards && cards.length) {
      setVisible(() => {
        const filteredCards = cards.filter((card: Farecard) => cardsIsVisbleCard(card));
        itemsRef.current = filteredCards.map((_, i) => itemsRef.current[i] ?? React.createRef());
        return filteredCards;
      });
    }
  }, [cards]);

  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={true}
      >
        {visible.map((item: Farecard, index) => {
          return (
          <SwiperSlide key={`${item.cardId}-${item.nickname}`}>
            <FarecardListItem
              item={item}
              unlock={unlock}
              goToAdd={goToAdd}
              addValue={addValue}
              showOptions={showOptions}
              ref={itemsRef.current[index]}
              
            />
          </SwiperSlide>
        )})}
      </Swiper>
    </>
  );
}
